export * from './Async';
export * from './AutoScroll';
export * from './BaseComponent';
export * from './BaseComponent.types';
export * from './DelayedRender';
export * from './EventGroup';
export * from './FabricPerformance';
export * from './GlobalSettings';
export * from './IClassNames';
export * from './IComponentAs';
export * from './IDisposable';
export * from './Point';
export * from './IRectangle';
export * from './IRenderComponent';
export * from './IRenderFunction';
export * from './ISize';
export * from './IStyleFunction';
export * from './KeyCodes';
export * from './Rectangle';
export * from './appendFunction';
export * from './aria';
export * from './array';
export * from './asAsync';
export * from './assertNever';
export * from './classNamesFunction';
export * from './componentAs/composeComponentAs';
export * from './controlled';
export * from './createRef';
export * from './css';
export * from './customizations/Customizations';
export * from './customizations/Customizer';
export * from './customizations/Customizer.types';
export * from './customizations/CustomizerContext';
export * from './customizations/customizable';
export * from './customizations/useCustomizationSettings';
export * from './customizations/mergeCustomizations';
export * from './customizations/mergeSettings';
export * from './dom';
export * from './extendComponent';
export * from './focus';
export * from './getId';
export * from './getNativeElementProps';
export * from './hoist';
export * from './hoistStatics';
export * from './initializeComponentRef';
export * from './initializeFocusRects';
export * from './useFocusRects';
export * from './initials';
export * from './keyboard';
export * from './language';
export * from './math';
export * from './memoize';
export * from './merge';
export * from './mobileDetector';
export * from './modalize';
export { assign, filteredAssign, mapEnumByName, shallowCompare, values, omit } from './object';
export * from './osDetector';
export * from './overflow';
export * from './properties';
export * from './renderFunction/composeRenderFunction';
export * from './resources';
export * from './rtl';
export * from './safeRequestAnimationFrame';
export * from './safeSetTimeout';
export * from './scroll';
export * from './selection/index';
export * from './string';
export * from './styled';
export * from './warn';
export * from './ie11Detector';
export * from './getPropsWithDefaults';
export { setFocusVisibility, IsFocusVisibleClassName } from './setFocusVisibility';
export { setSSR } from './dom/setSSR';
export { createMergedRef } from './createMergedRef';

import './version';

// eslint-disable-next-line deprecation/deprecation
export type { IStyleFunctionOrObject, Omit } from '@fluentui/merge-styles';
